module.exports = __webpack_public_path__ + "static/media/assignee-icon.1604bcf7.svg";